import {IAuthenticatedUserState} from "../../state/security/authenticated-user.state";
import {IAppState} from "../../state/app.state";
import {createSelector} from "@ngrx/store";


export const selectAuthenticatedUser = createSelector(
  (state: IAppState) => state.authenticatedUser,
  (state: IAuthenticatedUserState) => state.data
);
